module.exports = __webpack_public_path__ + "static/img/3.3aa159b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/3.jpg
// module id = 0B9a
// module chunks = 12